var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMerchMenuIcon = function SvgMerchMenuIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "menu-item-merch",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 19.237
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.979 0C3.338 2.127 3.44 2.49 0 6.261l3.255 3.686 1.138-.985v10.167c5.707.143 6.51.143 12.217 0V8.962l1.138.985L21 6.261C17.56 2.49 17.662 2.127 13.021 0a4.376 4.376 0 0 1-5.042 0Z",
    fillRule: "evenodd"
  })));
};
export default SvgMerchMenuIcon;